const png = 'image/png';
const jpeg = 'image/jpeg';

export default {
    pdf: 'application/pdf',
    png,
    jpeg,
    images: [ png, jpeg ],
};
